export default __webpack_public_path__ + "static/media/token-accrual-large.2f71f4ea.png";